<script setup lang="ts">
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import { useRouter } from 'vue-router';
import AddIcon from '@shared/assets/icon/add-circle-white.svg';
const router = useRouter();

function goToGettingStarted() {
  router.push({ name: 'ComGettingStarted' });
}
</script>

<template>
  <main class="content">
    <h2 id="welcome-title">Welcome to the SolShare commissioning app.</h2>

    <p id="ask">What would you like to do?</p>

    <ButtonPrimary
      @click="goToGettingStarted"
      size="large"
      class="commission-btn"
      data-tn="commission-solshare"
      block
    >
      <div class="commission-btn-content">
        <div class="commission-btn-icon">
          <AddIcon />
        </div>
        <div class="commission-btn-label">
          Commission a
          <span class="next-line">SolShare</span>
        </div>
      </div>
    </ButtonPrimary>
  </main>
</template>

<style lang="less" scoped>
@import '../../../assets/style/variables';

.content {
  background-color: @color-background-dark;
  min-height: 100vh;
  align-items: flex-start;

  #welcome-title {
    font-weight: @font-weight-bold !important;
  }

  #ask {
    margin-bottom: 20px;
  }

  .commission-btn-content {
    height: 135px;
    padding-top: 15px;
    padding-left: 4px;

    .commission-btn-icon {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      color: @color-primary;
    }

    .commission-btn-label {
      font-size: 28px;
      font-weight: @font-weight-regular;
      line-height: 32px;
      margin-top: 15px;
      text-align: left;

      .next-line {
        display: block;
      }
    }
  }

  .svg-icon {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
  }

  .svg-icon--fleet {
    position: relative;
    top: 3px;
  }

  /deep/ .commission-btn {
    margin-bottom: 20px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);

    .btn-flex-wrap {
      justify-content: flex-start;
    }

    &.ant-btn {
      height: 135px;
    }

    &:hover {
      box-shadow: none;
    }
  }

  /deep/ .non-commission-btn {
    margin-bottom: 9px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    font-weight: @font-weight-medium;

    .btn-flex-wrap {
      justify-content: flex-start;
    }

    .btn-main-content {
      width: 100%;
      justify-content: flex-start;
      text-align: left;
    }

    .left-icon {
      left: 0.3rem;
    }

    .btn-text {
      padding-left: 2.3rem;
    }
  }
}
</style>
